<div class="modalPlans">
    <div class="contenidoModal">
      <div class="header">
        <h2 class="titleCambio">Cambio de Plan</h2>
        <img src="/assets/icono/equis.svg" class="cerrar mr-2" (click)="closeModalUpgrade()" alt=""/>
      </div>
      <div>
          <img src="{{imagen}}" class="imagenFondo" alt="" />
      </div>
      <div class="bajada">
        <div class="descripcionPlan">
          <img src="/assets/icono-plans/{{iconplan}}" class="iconoPlan" alt=""/>
          <h2 class=" titlePlan mt-2" >{{titleplan}}</h2>
          <div class="descripcion" [innerHTML]="descriptionplan"></div>
        </div>
        <div class="proceso">
            <span class="title2">¿Cómo es el proceso?</span>
            <div class="descripProceso mt-2" [innerHTML]="processplan"></div>  
        </div> 
      </div>
      <div class="botones">
        <button class="cancelar" (click)="closeModalUpgrade()">Cancelar</button>
        <button class ="cambiarme" (click)="openFormUpgrade()">Completar Formulario</button>
      </div>
 </div>
</div>
